import React, { Component } from "react";
import Footer from "../../common/Footer.js";
import ClientSideNav from "../../common/ClientSideNav";
import TopNav from "../../common/TopNav.js";
import * as moment from "moment";
import debounce from "lodash.debounce";
import download from "downloadjs";
import { Table } from "react-bootstrap";
import requireAuth from "../../hoc/requireAuth";
import Swal from "sweetalert2/dist/sweetalert2.js";
import authorizeClient from "../../hoc/authorizeClient";
import NotAccessablePage from "../NotAccessablePage.js";
import { getNewSortOrder } from "../../helpers.js";
// Bootstrap CSS
import "bootstrap/dist/css/bootstrap.min.css";
// To make rows collapsible
import "bootstrap/js/src/collapse.js";
import Loader from "react-loader-spinner";
import DateRangePicker from "react-bootstrap-daterangepicker";
import { connect } from "react-redux";
import "bootstrap-daterangepicker/daterangepicker.css";
import {
  castToDefaultDateFormat,
  castToServerDateFormat,
} from "../../settings/index";
import { changeClientDateFilter } from "../../store/actions/filterActions";
import { withAlert } from "react-alert";
import InfrigementStatusDropdownComponent from "./../../components/InfrigementStatusDropdownComponent";
import "./ecommerceDashboard.css";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

class EcommerceDashboard extends Component {
  constructor(props) {
    super(props);
    this.getEcommerceData = debounce(this.getEcommerceData.bind(this), 1000);
    this.handleSelect = this.handleSelect.bind(this);

    this.state = {
      sorting: {
        sortBy: "",
        sortIconClass: "sort-icon-nutral",
        sortOrder: "",
      },
      authorised: true,
      domainUniqueSites: [],
      allSelected: false,
      selectedDomains: [],
      visibleRecords: "",
      dropdownCount: false,
      domains: [],
      pagination: {
        page: 1,
        nextPage: 1,
        prevPage: null,
        hasNextPage: true,
        hasPrevPage: false,
        pagingCounter: 1,
        totalDocs: null,
        totalPages: null,
      },
      perPage: 10,
      hasMoreDomainData: true,
      isLoading: false,
      locale: { format: "DD/MM/YYYY" },
      isDownloading: false,
      isDisabledApproveAll: true,
    };

    window.onscroll = debounce(async () => {
      const {
        getEcommerceData,
        state: { hasMoreDomainData, dropdownCount },
      } = this;

      if (!hasMoreDomainData) {
        return;
      }

      // Calculate the scroll position
      const scrollPosition =
        window.innerHeight + document.documentElement.scrollTop;

      // Check if scrolled to the bottom
      if (scrollPosition === document.documentElement.offsetHeight) {
        if (dropdownCount) {
          // Set dropdownCount to false to fetch all data
          this.setState({ dropdownCount: false });
        } else {
          // Paginate the data
          await getEcommerceData();
        }
      }
    }, 100);
  }

  handleSelectAll = (e) => {
    const checked = e.target.checked;

    const allDomainObjects = this.state.domains.map((domain) => ({
      _id: domain.id,
      company: domain.company.id,
      brand: domain.brand.id,
      url: domain.url,
    }));

    this.setState({
      allSelected: checked,
      selectedDomains: checked ? allDomainObjects : [],
      isDisabledApproveAll: false,
    });
  };

  handleRowSelect = (domain) => {
    const { selectedDomains, domains } = this.state;

    const isAlreadySelected = selectedDomains.some((d) => d._id === domain.id);

    let updatedSelection;
    if (isAlreadySelected) {
      // Remove domain from selection
      updatedSelection = selectedDomains.filter((d) => d._id !== domain.id);
    } else {
      // Add domain to selection
      updatedSelection = [
        ...selectedDomains,
        {
          _id: domain.id,
          company: domain.company.id,
          brand: domain.brand.id,
          url: domain.url,
        },
      ];
    }

    this.setState({
      selectedDomains: updatedSelection,
      allSelected: updatedSelection.length === domains.length,
      isDisabledApproveAll: updatedSelection.length > 0 ? false : true,
    });
  };

  handleBulkAction = async () => {
    const options = {
      headers: { "Content-Type": "application/json" },
    };
    this.setState({ isDisabledApproveAll: true });

    await window.axios
      .post(
        `/ecommerce/update-bulk-infrigement-status`,
        {
          recordIds: this.state.selectedDomains,
          module: "E-Commerce-Dashboard",
          statusfrom: "33",
          status: "22",
          platform: "e-commerce",
        },
        options,
      )
      .then((_) => {
        this.setState({ allSelected: false, selectedDomains: [] });
        this.getEcommerceData();
        this.props.alert.success("Record successfully updated");
      })
      .catch(function (error) {
        this.props.alert.success("Something went wrong");
        this.setState({ isDisabledApproveAll: false });
      });
  };

  changeSorting(sortBy) {
    this.setState((prevState) => {
      const { sortOrder, classPostFix } = getNewSortOrder(prevState);

      return {
        sorting: {
          sortBy,
          sortIconClass: `sort-icon-${classPostFix}`,
          sortOrder,
        },
      };
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.sorting.sortBy !== this.state.sorting.sortBy ||
      prevState.sorting.sortOrder !== this.state.sorting.sortOrder ||
      prevProps.selectedBrand !== this.props.selectedBrand ||
      prevProps.clientEcommerceFilter !== this.props.clientEcommerceFilter ||
      prevProps.clientDateFilter !== this.props.clientDateFilter ||
      prevProps.location?.state?.notification !==
        this.props.location?.state?.notification
    ) {
      this.getEcommerceData(true);
    }

    if (prevState.domains.length !== this.state.domains.length) {
      this.setState({ visibleRecords: this.state.domains.length }, () => {});
    }
  }

  async downloadExcel(type) {
    if (this.state.pagination.totalDocs > 25000) {
      Swal.fire(
        "More than 25,000 records cannot be downloaded. Please contact administrator.",
        "",
        "warning",
      );
      return; // Stop execution if the limit is exceeded
    }

    this.setState({ isDownloading: true });
    const reqData = {
      startDate: castToServerDateFormat(this.props.clientDateFilter.startDate),
      endDate: castToServerDateFormat(this.props.clientDateFilter.endDate),
      module: "e-commerce",
      type,
      ...this.props?.clientEcommerceFilter,
    };

    if (this.props.selectedBrand?.id) {
      reqData.brand = this.props.selectedBrand.id;
    }

    if (this.props.selectedCompany?.id) {
      reqData.clientCompanyId = this.props.selectedCompany.id;
    }

    try {
      const response = await window.axios.get("/ecommerce/download-xls", {
        params: reqData,
        responseType: "blob",
        timeout: 30000,
      });

      const isCSV = type === "csv";
      const mimeType = isCSV
        ? "text/csv"
        : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      const filename = isCSV ? "ecommerce.csv" : "ecommerce.xlsx";
      download(response.data, filename, mimeType);
    } catch (error) {
      console.error("Error downloading Excel file:", error);
      Swal.fire("Download failed. Please try again later.", "", "error");
    } finally {
      // Re-enable buttons after download attempt
      this.setState({ isDownloading: false });
    }
  }

  async getEcommerceData(reArrangeRecords = false) {
    const options = {
      headers: { "Content-Type": "application/json" },
    };

    let reqData = {
      dropdownCount: this.state.dropdownCount,
      sortBy: this.state.sorting.sortBy,
      sortOrder: this.state.sorting.sortOrder,
      page: reArrangeRecords ? 1 : this.state.pagination.nextPage, // Use nextPage for pagination
      perPage: this.state.perPage,
      startDate: castToServerDateFormat(this.props.clientDateFilter.startDate),
      endDate: castToServerDateFormat(this.props.clientDateFilter.endDate),
      ...this.props.clientEcommerceFilter,
    };

    if (this.props.location?.state?.notification) {
      reqData.notification = this.props.location?.state?.notification;
    }

    if (this.props.selectedBrand?.id) {
      reqData.brand = this.props.selectedBrand?.id;
    }

    if (this.props.selectedCompany?.id) {
      reqData.clientCompanyId = this.props.selectedCompany?.id;
    }

    reqData.module = "e-commerce";
    this.setState({ isLoading: true });

    try {
      const res = await window.axios.get(
        "/ecommerce",
        { params: reqData },
        options,
      );

      let domainData = res.data.docs;

      if (reArrangeRecords) {
        this.setState({
          domains: domainData,
          pagination: {
            page: res.data.page,
            nextPage: res.data.nextPage,
            prevPage: res.data.prevPage,
            hasNextPage: res.data.hasNextPage,
            hasPrevPage: res.data.hasPrevPage,
            pagingCounter: res.data.pagingCounter,
            totalDocs: res.data.totalDocs,
            totalPages: res.data.totalPages,
          },
          hasMoreDomainData: res.data.hasNextPage,
          isLoading: false,
        });
        return;
      }

      if (reqData.dropdownCount) {
        domainData = res.data.docs; // Only update with the current response data
      } else if (this.state.domains.length > 0) {
        domainData = this.state.domains.concat(domainData); // Append new data to existing data
      }

      this.setState({
        pagination: {
          page: res.data.page,
          nextPage: res.data.nextPage,
          prevPage: res.data.prevPage,
          hasNextPage: res.data.hasNextPage,
          hasPrevPage: res.data.hasPrevPage,
          pagingCounter: res.data.pagingCounter,
          totalDocs: res.data.totalDocs,
          totalPages: res.data.totalPages,
        },
        domains: domainData,
        hasMoreDomainData: res.data.hasNextPage,
        isLoading: false,
      });
      this.setState({ domainUniqueSites: res.data.domainUniqueSites });
    } catch (error) {
      // Handle error
      this.setState({ isLoading: false });
      console.error("Error fetching ecommerce data:", error);
    }
  }

  getDateFilters() {
    return {
      startDate: moment(this.props.clientDateFilter.startDate),
      endDate: moment(this.props.clientDateFilter.endDate),
      locale: this.state.locale,
    };
  }

  handleCallback = async (event, picker) => {
    this.props.dispatch(
      changeClientDateFilter({
        startDate: picker.startDate,
        endDate: picker.endDate,
      }),
    );
  };

  renderLoader() {
    if (this.state.isLoading) {
      return (
        <div className="text-center">
          <Loader
            type="ThreeDots"
            color="#00BFFF"
            height={10}
            width={200}
            timeout={5000} //3 secs
          />
        </div>
      );
    }
  }

  componentDidMount() {
    this.getEcommerceData();
    this.setState({ visibleRecords: this.state.domains.length }, () => {});
  }

  updateClientCommentInArray(value, key) {
    let records = this.state.domains;

    records[key]["clientComment"] = value;

    this.setState(() => ({
      domains: records,
    }));
  }

  async updateClientCommentToDatabase(key) {
    let clientComment = this.state.domains[key]["clientComment"];
    let infrigementId = this.state.domains[key]["id"];

    if (!clientComment) {
      return;
    }

    const options = {
      headers: { "Content-Type": "application/json" },
    };

    await window.axios
      .post(
        `/ecommerce/${infrigementId}/update-client-comment`,
        {
          clientComment,
        },
        options,
      )
      .then((res) => {
        this.props.alert.success("Comment upated successfully.");
      })
      .catch(function (error) {
        this.props.alert.error(error.response.data.message);
      });
  }

  handleSelect(countValue) {
    this.setState(
      {
        perPage: countValue,
        dropdownCount: countValue,
        domains: [],
        visibleRecords: 0,
        hasMoreDomainData: true,
        pagination: {
          page: 1,
          nextPage: 1,
          prevPage: null,
          hasNextPage: true,
          hasPrevPage: false,
          pagingCounter: 1,
          totalDocs: null,
          totalPages: null,
        },
      },
      () => {
        this.getEcommerceData(true); // force fresh load
      },
    );
  }

  handleNewTab(sellerName) {
    const sellerData = { sellerName: sellerName };
    const queryString = new URLSearchParams(sellerData).toString();
    if (sellerName == null || sellerName === "") {
      return;
    }
    window.open(`/unique-seller-dashboard?${queryString}`);
  }

  printPaginationInfo() {
    let totalDocs = this.state.pagination.totalDocs
      ? this.state.pagination.totalDocs
      : 0;
    let visibleRecords = 0;

    if (totalDocs) {
      visibleRecords =
        totalDocs > this.state.perPage * this.state.pagination.page
          ? this.state.perPage * this.state.pagination.page
          : totalDocs;
    }

    return (
      <>
        <div className="d-flex align-items-center">
          <span className="text-uppercase page-subtitle">
            Showing{" "}
            <strong>
              {/* {this.state.dropdownRecordsPlug
                ? this.state.dropdownRecords.length
                : visibleRecords} */}
              {this.state.visibleRecords}
            </strong>{" "}
            records of <strong>{totalDocs}</strong>
          </span>
          <div className="dropdown ml-3">
            <button
              className="btn btn-secondary dropdown-toggle custom-dropdown-button"
              type="button"
              id="dropdownMenuButton"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              style={{
                backgroundColor: "white",
                width: "130px",
                color: "black", // Add the color property for text visibility
                height: "20px", // Adjust the height as per your requirements
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                lineHeight: "1",
              }}
            >
              {/* {this.state.dropdownRecordsPlug
                ? this.state.dropdownRecords.length
                : visibleRecords} */}
              {this.state.visibleRecords} Records
            </button>
            <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
              <a
                className="dropdown-item"
                href="#"
                onClick={() => this.handleSelect(10)}
              >
                Show 10 records
              </a>
              <a
                className="dropdown-item"
                href="#"
                onClick={() => this.handleSelect(20)}
              >
                Show 20 records
              </a>
              <a
                className="dropdown-item"
                href="#"
                onClick={() => this.handleSelect(50)}
              >
                Show 50 records
              </a>
            </div>
          </div>
        </div>
      </>
    );
  }

  renderHtml() {
    if (!this.props.selectedBrand?.platforms?.eCommerce) {
      return <NotAccessablePage />;
    }

    return (
      <div className="row">
        <ClientSideNav domainUniqueSites={this.state.domainUniqueSites} />

        <main className="main-content col-lg-10 col-md-9 col-sm-12 p-0 offset-lg-2 offset-md-3">
          <TopNav />

          <div className="main-content-container container-fluid px-4">
            <div className="page-header row no-gutters py-4">
              <div className="col-12">
                <div className="row">
                  <div className="col-3 text-sm-left mb-0">
                    <span className="text-uppercase page-subtitle">
                      E-Commerce Dashboard
                    </span>
                    {this.printPaginationInfo()}
                  </div>
                  <div className="col-2 text-sm-right mb-0">
                    {this.renderLoader()}
                  </div>
                  <div className="col-5 text-sm-right mb-0">
                    <span>
                      <strong>Reporting Date: </strong>
                    </span>
                    <DateRangePicker
                      onApply={this.handleCallback}
                      initialSettings={this.getDateFilters()}
                      alwaysShowCalendars={true}
                    >
                      <input className="from-control" />
                    </DateRangePicker>
                  </div>
                  <div
                    className="col-1 text-sm-right mr-4"
                    style={{ margin: "-5px" }}
                  >
                    <div
                      className="btn-group"
                      role="group"
                      aria-label="Download Buttons"
                    >
                      <button
                        type="button"
                        className="btn btn-outline-secondary"
                        style={{ minWidth: "80px" }}
                        onClick={() => this.downloadExcel("csv")}
                        disabled={this.state.isDownloading}
                      >
                        CSV
                      </button>
                      <button
                        type="button"
                        className="btn btn-outline-secondary"
                        style={{ minWidth: "80px" }}
                        onClick={() => this.downloadExcel("excel")}
                        disabled={this.state.isDownloading}
                      >
                        Excel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="d-flex justify-content-end align-items-center mb-3 px-3">
              {this.props.clientEcommerceFilter.status === "33" && (
                <button
                  onClick={this.handleBulkAction}
                  style={{
                    padding: "8px 16px",
                    backgroundColor:
                      this.state.selectedDomains.length === 0
                        ? "#ccc"
                        : "#007bff",
                    color: "#fff",
                    border: "none",
                    borderRadius: "4px",
                    cursor:
                      this.state.selectedDomains.length === 0
                        ? "not-allowed"
                        : "pointer",
                    transition: "background-color 0.3s ease",
                  }}
                  disabled={this.state.isDisabledApproveAll}
                >
                  Approve All
                </button>
              )}
            </div>

            <div id="scrollableDiv" style={{ overflow: "hidden" }}>
              <div className="row">
                <div className="col">
                  {/* table here */}
                  <Table className="table-responsive">
                    <thead className="uppercase-text">
                      <tr>
                        {this.props.clientEcommerceFilter.status === "33" && (
                          <th scope="col" width="5%" className="border-0">
                            <input
                              type="checkbox"
                              onChange={this.handleSelectAll}
                              checked={this.state.allSelected}
                            />
                            <span className="m-2">All</span>
                          </th>
                        )}
                        <th scope="col" width="3%" className="border-0">
                          {" "}
                          #
                        </th>
                        <th
                          width="3%"
                          scope="col"
                          className="border-0 text-uppercase"
                        >
                          Image
                        </th>
                        <th
                          width="10%"
                          scope="col"
                          onClick={(e) => this.changeSorting("title")}
                          className={`border-0 text-uppercase ${
                            this.state.sorting.sortBy === "title"
                              ? this.state.sorting.sortIconClass + " sort-icon"
                              : "sort-icon sort-icon-nutral"
                          }`}
                        >
                          Title
                        </th>
                        <th
                          width="10%"
                          scope="col"
                          onClick={(e) => this.changeSorting("site")}
                          className={`border-0 text-uppercase ${
                            this.state.sorting.sortBy === "site"
                              ? this.state.sorting.sortIconClass + " sort-icon"
                              : "sort-icon sort-icon-nutral"
                          }`}
                        >
                          Site
                        </th>
                        <th
                          width="10%"
                          scope="col"
                          onClick={(e) => this.changeSorting("reportingDate")}
                          className={`border-0 text-uppercase ${
                            this.state.sorting.sortBy === "reportingDate"
                              ? this.state.sorting.sortIconClass + " sort-icon"
                              : "sort-icon sort-icon-nutral"
                          }`}
                        >
                          Reporting Date
                        </th>
                        <th
                          width="10%"
                          scope="col"
                          onClick={(e) => this.changeSorting("priority")}
                          className={`border-0 text-uppercase ${
                            this.state.sorting.sortBy === "priority"
                              ? this.state.sorting.sortIconClass + " sort-icon"
                              : "sort-icon sort-icon-nutral"
                          }`}
                        >
                          Priority
                        </th>
                        <th
                          width="10%"
                          scope="col"
                          onClick={(e) => this.changeSorting("status")}
                          className={`border-0 text-uppercase ${
                            this.state.sorting.sortBy === "status"
                              ? this.state.sorting.sortIconClass + " sort-icon"
                              : "sort-icon sort-icon-nutral"
                          }`}
                        >
                          Status
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.domains.map((domain, key) => {
                        // Your code logic for each domain

                        return (
                          <>
                            <tr
                              key={domain?.id}
                              data-toggle="collapse"
                              data-target={".multi-collapse" + key}
                              aria-controls={"multiCollapseExample" + key}
                            >
                              {this.props.clientEcommerceFilter.status ===
                                "33" && (
                                <td>
                                  <input
                                    type="checkbox"
                                    onChange={() =>
                                      this.handleRowSelect(domain)
                                    }
                                    checked={this.state.selectedDomains.some(
                                      (d) => d._id === domain.id,
                                    )}
                                  />
                                </td>
                              )}
                              <td>{key + 1}</td>
                              <td>
                                <img
                                  className="user-avatar"
                                  width="50"
                                  src={domain.imageUrl}
                                  alt={domain.title}
                                />
                              </td>
                              <td>
                                {" "}
                                <a
                                  href={domain.url}
                                  target="_blank"
                                  title={domain.title}
                                  className="bind-width"
                                >
                                  <p
                                    title={domain.title}
                                    className="bind-width"
                                  >
                                    {domain.title}
                                  </p>
                                </a>
                              </td>
                              <td>
                                <p className="bind-width" title={domain.site}>
                                  {domain.site}
                                </p>{" "}
                              </td>
                              <td>
                                {" "}
                                <p
                                  title={castToDefaultDateFormat(
                                    domain.reportingDate,
                                  )}
                                  className="bind-width"
                                >
                                  {castToDefaultDateFormat(
                                    domain.reportingDate,
                                  )}
                                </p>
                              </td>
                              <td>{domain.priority}</td>
                              <td>
                                <InfrigementStatusDropdownComponent
                                  selectedInfrigemnt={domain}
                                  selectedInfrigemntIndex={key}
                                  infrigementType="e-commerce"
                                />
                              </td>
                            </tr>
                            <tr
                              className={"collapse multi-collapse" + key}
                              id={"multiCollapseExample" + key}
                            >
                              <td colSpan={10}>
                                <div className="row ">
                                  <div
                                    className="col-md-3 "
                                    // style={{ marginBottom: "-250px" }}
                                    style={{ height: "10px" }}
                                  >
                                    <img
                                      data-toggle="modal"
                                      width="200"
                                      height="100"
                                      data-target={"#myModal" + key}
                                      src={domain.imageUrl}
                                      className="mr-2"
                                      alt="Cinque Terre"
                                      style={{ marginBottom: "20px" }}
                                    />

                                    <div
                                      className="input-box"
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        height: "560px", // or use fixed height like "300px"
                                        padding: "20px", // optional
                                      }}
                                    >
                                      <span className="text-muted d-block mb-2">
                                        Reason
                                      </span>

                                      <textarea
                                        value={domain.reason}
                                        className="input-content"
                                        style={{
                                          flex: 1,
                                          resize: "none",
                                          minHeight: "100px", // optional safety for very short content
                                        }}
                                      ></textarea>

                                      <span className="text-muted d-block mb-2">
                                        Reason Code
                                      </span>

                                      <OverlayTrigger
                                        placement="left"
                                        overlay={
                                          <Tooltip id="tooltip">
                                            {domain.reasonCode}
                                          </Tooltip>
                                        }
                                      >
                                        <input
                                          type="text"
                                          value={domain.reasonCode}
                                          disabled
                                          className="form-control"
                                          placeholder="Username"
                                          aria-label="Username"
                                          aria-describedby="basic-addon1"
                                          style={{
                                            marginTop: "10px",
                                          }}
                                        />
                                      </OverlayTrigger>

                                      <br />
                                      <br />
                                    </div>
                                  </div>

                                  <div className="col-md-9">
                                    <div className="row">
                                      {/* Title */}
                                      <div className="col-md-6">
                                        <div className="form-group">
                                          <span className="text-muted d-block mb-2">
                                            Title
                                          </span>
                                          <OverlayTrigger
                                            placement="left"
                                            overlay={
                                              <Tooltip id="tooltip">
                                                {domain.title}
                                              </Tooltip>
                                            }
                                          >
                                            <input
                                              type="text"
                                              value={domain.title}
                                              disabled
                                              className="form-control"
                                              placeholder="Username"
                                              aria-label="Username"
                                              aria-describedby="basic-addon1"
                                            />
                                          </OverlayTrigger>
                                        </div>
                                      </div>

                                      {/* Site */}
                                      <div className="col-md-6">
                                        <div className="form-group">
                                          <span
                                            className="text-muted d-block mb-2"
                                            data-toggle="tooltip"
                                            data-html="true"
                                            title={domain.site}
                                          >
                                            Site
                                          </span>
                                          <OverlayTrigger
                                            placement="left"
                                            overlay={
                                              <Tooltip id="tooltip">
                                                {domain.site}
                                              </Tooltip>
                                            }
                                          >
                                            <input
                                              type="text"
                                              value={domain.site}
                                              disabled
                                              className="form-control"
                                              placeholder="Username"
                                              aria-label="Username"
                                              aria-describedby="basic-addon1"
                                            />
                                          </OverlayTrigger>
                                        </div>
                                      </div>

                                      {/* Price */}
                                      <div className="col-md-6">
                                        <div className="form-group">
                                          <span className="text-muted d-block mb-2">
                                            Price
                                          </span>{" "}
                                          <OverlayTrigger
                                            placement="left"
                                            overlay={
                                              <Tooltip id="tooltip">
                                                {domain.price}
                                              </Tooltip>
                                            }
                                          >
                                            <input
                                              type="text"
                                              value={domain.price}
                                              disabled
                                              className="form-control"
                                              placeholder=""
                                              aria-label="Username"
                                              aria-describedby="basic-addon1"
                                            />
                                          </OverlayTrigger>
                                        </div>
                                      </div>

                                      {/* MRP */}
                                      <div className="col-md-6">
                                        <div className="form-group">
                                          <span className="text-muted d-block mb-2">
                                            MRP
                                          </span>{" "}
                                          <OverlayTrigger
                                            placement="left"
                                            overlay={
                                              <Tooltip id="tooltip">
                                                {domain.mrp}
                                              </Tooltip>
                                            }
                                          >
                                            <input
                                              type="text"
                                              value={domain.mrp}
                                              disabled
                                              className="form-control"
                                              placeholder=""
                                              aria-label="Username"
                                              aria-describedby="basic-addon1"
                                            />
                                          </OverlayTrigger>
                                        </div>
                                      </div>

                                      {/* Priority */}
                                      <div className="col-md-6">
                                        <div className="form-group">
                                          <span className="text-muted d-block mb-2">
                                            Priority
                                          </span>
                                          <OverlayTrigger
                                            placement="left"
                                            overlay={
                                              <Tooltip id="tooltip">
                                                {domain.priority}
                                              </Tooltip>
                                            }
                                          >
                                            <input
                                              type="text"
                                              value={domain.priority}
                                              disabled
                                              className="form-control"
                                              placeholder="Username"
                                              aria-label="Username"
                                              aria-describedby="basic-addon1"
                                            />
                                          </OverlayTrigger>
                                        </div>
                                      </div>

                                      {/* Brand Name */}
                                      <div className="col-md-6">
                                        <div className="form-group">
                                          <span className="text-muted d-block mb-2">
                                            Brand Name
                                          </span>
                                          <OverlayTrigger
                                            placement="left"
                                            overlay={
                                              <Tooltip id="tooltip">
                                                {domain.brand.brandName}
                                              </Tooltip>
                                            }
                                          >
                                            <input
                                              type="text"
                                              value={domain.brand.brandName}
                                              disabled
                                              className="form-control"
                                              placeholder=""
                                              aria-label="Username"
                                              aria-describedby="basic-addon1"
                                            />
                                          </OverlayTrigger>
                                        </div>
                                      </div>
                                    </div>

                                    {/* Seller Section */}
                                    <div className="row mt-3">
                                      <div className="col-md-12">
                                        <h5>Seller</h5>
                                      </div>

                                      {/* Username */}
                                      <div className="col-md-6">
                                        <div className="form-group">
                                          <span className="text-muted d-block mb-2">
                                            Username
                                          </span>
                                          <OverlayTrigger
                                            placement="left"
                                            overlay={
                                              <Tooltip id="tooltip">
                                                {domain.username}
                                              </Tooltip>
                                            }
                                          >
                                            <input
                                              type="text"
                                              value={`${domain.username} - ${domain.sellerCountInCompany} / ${domain.sellerCountOutsideCompany} `}
                                              readOnly
                                              className="form-control"
                                              placeholder="Username"
                                              aria-label="Username"
                                              aria-describedby="basic-addon1"
                                              style={{ cursor: "pointer" }}
                                              onClick={() =>
                                                this.handleNewTab(
                                                  domain.username,
                                                )
                                              }
                                            />
                                          </OverlayTrigger>
                                        </div>
                                      </div>

                                      {/* Seller Rating */}
                                      <div className="col-md-6">
                                        <div className="form-group">
                                          <span className="text-muted d-block mb-2">
                                            Seller Rating
                                          </span>
                                          <OverlayTrigger
                                            placement="left"
                                            overlay={
                                              <Tooltip id="tooltip">
                                                {domain.sellerRating}
                                              </Tooltip>
                                            }
                                          >
                                            <input
                                              type="text"
                                              value={domain?.sellerRating}
                                              disabled
                                              className="form-control"
                                              placeholder=""
                                              aria-label="Username"
                                              aria-describedby="basic-addon1"
                                            />
                                          </OverlayTrigger>
                                        </div>
                                      </div>

                                      {/* Id */}
                                      <div className="col-md-6">
                                        <div className="form-group">
                                          <span className="text-muted d-block mb-2">
                                            Id
                                          </span>
                                          <OverlayTrigger
                                            placement="left"
                                            overlay={
                                              <Tooltip id="tooltip">
                                                {domain.storeId}
                                              </Tooltip>
                                            }
                                          >
                                            <input
                                              type="text"
                                              value={domain.storeId}
                                              disabled
                                              className="form-control"
                                              placeholder=""
                                              aria-label="Username"
                                              aria-describedby="basic-addon1"
                                            />
                                          </OverlayTrigger>
                                        </div>
                                      </div>

                                      {/* Address */}
                                      <div className="col-md-6">
                                        <div className="form-group">
                                          <span className="text-muted d-block mb-2">
                                            Address
                                          </span>
                                          <OverlayTrigger
                                            placement="left"
                                            overlay={
                                              <Tooltip id="tooltip">
                                                {domain.address}
                                              </Tooltip>
                                            }
                                          >
                                            <input
                                              type="text"
                                              value={domain.address}
                                              disabled
                                              className="form-control"
                                              placeholder="Username"
                                              aria-label="Username"
                                              aria-describedby="basic-addon1"
                                            />
                                          </OverlayTrigger>
                                        </div>
                                      </div>

                                      {/* City */}
                                      <div className="col-md-6">
                                        <div className="form-group">
                                          <span className="text-muted d-block mb-2">
                                            City
                                          </span>
                                          <OverlayTrigger
                                            placement="left"
                                            overlay={
                                              <Tooltip id="tooltip">
                                                {domain.city}
                                              </Tooltip>
                                            }
                                          >
                                            <input
                                              type="text"
                                              value={domain.city}
                                              disabled
                                              className="form-control"
                                              placeholder="Username"
                                              aria-label="Username"
                                              aria-describedby="basic-addon1"
                                            />
                                          </OverlayTrigger>
                                        </div>
                                      </div>

                                      {/* Country */}
                                      <div className="col-md-6">
                                        <div className="form-group">
                                          <span className="text-muted d-block mb-2">
                                            Country
                                          </span>
                                          <OverlayTrigger
                                            placement="left"
                                            overlay={
                                              <Tooltip id="tooltip">
                                                {domain.country}
                                              </Tooltip>
                                            }
                                          >
                                            <input
                                              type="text"
                                              value={domain.country}
                                              disabled
                                              className="form-control"
                                              placeholder="Username"
                                              aria-label="Username"
                                              aria-describedby="basic-addon1"
                                            />
                                          </OverlayTrigger>
                                        </div>
                                      </div>
                                    </div>

                                    {/* ------------------------ comment section end here --------------------------- */}
                                    <div className="row">
                                      <div className="col-md-12">
                                        <span className="text-muted d-block mb-2">
                                          Comment
                                        </span>
                                        <div className="form-group d-flex align-items-center">
                                          <button
                                            style={{ marginRight: "10px" }}
                                            onClick={(e) =>
                                              this.updateClientCommentToDatabase(
                                                key,
                                              )
                                            }
                                            className="btn btn-success"
                                          >
                                            Update comment
                                          </button>

                                          <div className="flex-grow-1">
                                            <textarea
                                              onChange={(e) =>
                                                this.updateClientCommentInArray(
                                                  e.target.value,
                                                  key,
                                                )
                                              }
                                              className="form-control"
                                              value={
                                                domain?.clientComment
                                                  ?.comment || ""
                                              }
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    {/* ------------------------ comment section end here --------------------------- */}
                                  </div>
                                </div>
                              </td>
                            </tr>
                            <div className="modal" id={"myModal" + key}>
                              <div className="modal-dialog modal-800">
                                <div className="modal-content">
                                  <div className="modal-header">
                                    <h4 className="modal-title">Image</h4>
                                    <button
                                      type="button"
                                      className="close"
                                      data-dismiss="modal"
                                    >
                                      &times;
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                    <img
                                      src={domain.imageUrl}
                                      width="100%"
                                      className="img-responsive"
                                      alt="Cinque Terre"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </>
                        );
                      })}
                    </tbody>
                  </Table>
                </div>
              </div>
            </div>
          </div>

          <Footer />
        </main>
      </div>
    );
  }

  render() {
    return <>{this.renderHtml()}</>;
  }
}

const mapStateToProps = (state) => ({
  clientEcommerceFilter: state.clientEcommerceFilter,
  clientDateFilter: state.clientDateFilter,
});

export default withAlert()(
  connect(mapStateToProps)(authorizeClient(requireAuth(EcommerceDashboard))),
);
